import React, { useState } from 'react';
import { Row, Col, Input, InputGroup } from 'reactstrap';
import CompanyMemberEditModal from './CompanyMemberEditModal';
import DeleteModal from '../../../components/Util/DeleteModal';
import toastAlert from '../../../js/Base/ToastAlert';
import PaginationTableWithFuncBtn from '../../../components/Util/PaginationTableWithFuncBtn';
import { deleteCompanyMember } from '../../../api/companyApi';

export default function CompanyMemberTableBlock({ rows, search, refreshData }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectCompanyMember, setSelectCompanyMember] = useState(null);

  const filteredRows = rows.filter(
    (row) =>
      row.name.includes(search) || row.email.includes(search)
  );

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // 編輯 Modal
  const handleEditModalOpen = (member) => {
    setSelectCompanyMember(member);
    setIsModalOpen(true);
  };
  const handleEditModalClose = () => {
    setIsModalOpen(false);
    setSelectCompanyMember(null);
  };

  // 刪除 Modal
  const handleDeleteModalOpen = (member) => {
    setSelectCompanyMember(member);
    setDeleteModalOpen(true);
  };
  const handleDeleteModalClose = () => {
    setDeleteModalOpen(false);
    setSelectCompanyMember(null);
  };

  const handleDeleteConfirm = async () => {
    if (!selectCompanyMember) return;
    try {
      const response = await deleteCompanyMember(selectCompanyMember.uuid);
      const data = response.data;
      if (data.success) {
        toastAlert.autoClose(true).showSuccess("刪除成功");
        refreshData();
      } else {
        toastAlert.autoClose(true).showError("刪除失敗，請稍後再試");
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("刪除失敗，請稍後再試");
    } finally {
      handleDeleteModalClose();
    }
  };

  const col_name = ["姓名", "電子信箱", "狀態", "功能"];
  const data_frame = [
    { keyName: 'name', isBadge: false },
    { keyName: 'email', isBadge: false },
    { keyName: 'status', isBadge: false },
    { keyName: 'func', isClick: true, editBtn: true, delBtn: true },
  ];
  const col_size = ['25%', '42%', '15%', '18%'];
  const newCompanyMembers = rows.map((data) => ({
    ...data,
    status: data.status === 1 ? "啟用" : "停用",
  }));
  
  const handleEdit = (uuid) => {
    const member = newCompanyMembers.find((m) => m.uuid === uuid);
    handleEditModalOpen(member)
  };

  const handleDelete = (uuid) => {
    const member = newCompanyMembers.find((m) => m.uuid === uuid);
    handleDeleteModalOpen(member)
  };

  return (
    <>
      <div className="mt-3">
        <Row>
          <Col>
            {newCompanyMembers.length > 0 ? (
              <PaginationTableWithFuncBtn
                rowData={newCompanyMembers.filter((m) =>
                  m.name.indexOf(search) > -1 || m.email.indexOf(search) > -1
                )}
                colName={col_name}
                dataFrame={data_frame}
                col_size={col_size}
                delFunc={handleDelete}
                editModalOpen={handleEdit}
              />
            ) : (
              ''
            )}
          </Col>
        </Row>
      </div>
      <CompanyMemberEditModal
        isModalOpen={isModalOpen}
        handleClose={handleEditModalClose}
        companyMember={selectCompanyMember}
      />
      <DeleteModal
        isModalOpen={deleteModalOpen}
        handleClose={handleDeleteModalClose}
        handleUpdate={handleDeleteConfirm}
        title={'刪除帳號'}
        content={`請確認是否刪除該人員帳號：${selectCompanyMember?.name || ''}`}
      />
    </>
  );
}
